import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

type Tone = "dark" | "light";

interface NewsletterFormProps {
  tone?: Tone;
  className?: string;
  mode?: "script" | "iframe";
}

const FORM_ID = "ab397556-e32f-4365-895e-c3b9251920f2";
const FORM_URL = `https://subscribe-forms.beehiiv.com/v3/forms/${FORM_ID}`;

export function NewsletterForm({ className = "", mode = "script" }: NewsletterFormProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mode !== "script") return;
    const el = containerRef.current;
    if (!el) return;
    // Avoid double-injection if React re-runs the effect
    if (el.querySelector("script[data-beehiiv-form]")) return;
    const script = document.createElement("script");
    script.src = "https://subscribe-forms.beehiiv.com/v3/loader.js";
    script.async = true;
    script.setAttribute("data-beehiiv-form", FORM_ID);
    el.appendChild(script);
  }, [mode]);

  if (mode === "iframe") {
    return (
      <div className={cn("newsletter-form-embed newsletter-form-frame", className)}>
        <iframe
          src={FORM_URL}
          title="Subscribe to The Digital Debrief"
          loading="lazy"
          className="newsletter-form-frame__iframe"
        />
      </div>
    );
  }

  return <div ref={containerRef} className={cn("newsletter-form-embed", className)} />;
}
